module.exports = __webpack_public_path__ + "img/zh_cn.5a072ee5.png";